export enum attemptedConnectionType {
  Blocked,
  Reconnect,
  Connect
}
